var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.validateEmail
        ? _c("a", { attrs: { href: "mailto:" + _vm.value } }, [
            _vm._v(_vm._s(_vm.value))
          ])
        : _vm.validateUrl
        ? _c("a", { attrs: { href: "" + _vm.value, target: "_blank" } }, [
            _vm._v(_vm._s(_vm.value))
          ])
        : _c(
            "router-link",
            {
              staticClass: "link text-primary ripple",
              attrs: { to: _vm.clientRoute + "/edit/" + _vm.row.id + "/" }
            },
            [_vm._v(_vm._s(_vm.tableValue))]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }